import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedRowKeys: [],
  cryptoDepositData: null,
  cryptoWithdrawalData: null,
  inrDepositData: null,
  inrWithdrawalData: null,
  loadingCryptoDeposit: false,
  loadingCryptoWithdrawal: false,
  loadingInrDeposit: false,
  loadingInrWithdrawal: false,
  carretBankList: [],
  loadingCarretBankList: false,
};

const transactionSlice = createSlice({
  name: "transaction",
  initialState,
  reducers: {
    setSelectedRowKeys: (state, action) => {
      state.selectedRowKeys = action.payload;
    },
    clearSelectedRowKeys: (state) => {
      state.selectedRowKeys = [];
    },
    setCryptoDepositData: (state, action) => {
      state.cryptoDepositData = action.payload;
    },
    setCryptoWithdrawalData: (state, action) => {
      state.cryptoWithdrawalData = action.payload;
    },
    setInrDepositData: (state, action) => {
      state.inrDepositData = action.payload;
    },
    setInrWithdrawalData: (state, action) => {
      state.inrWithdrawalData = action.payload;
    },
    clearAllTransactionData: (state) => {
      state.cryptoDepositData = null;
      state.cryptoWithdrawalData = null;
      state.inrDepositData = null;
      state.inrWithdrawalData = null;
    },
    setLoadingCryptoDeposit: (state, action) => {
      state.loadingCryptoDeposit = action.payload;
    },
    setLoadingCryptoWithdrawal: (state, action) => {
      state.loadingCryptoWithdrawal = action.payload;
    },
    setLoadingInrDeposit: (state, action) => {
      state.loadingInrDeposit = action.payload;
    },
    setLoadingInrWithdrawal: (state, action) => {
      state.loadingInrWithdrawal = action.payload;
    },
    setCarretBankList: (state, action) => {
      state.carretBankList = action.payload;
    },
    setLoadingCarretBankList: (state, action) => {
      state.loadingCarretBankList = action.payload;
    },
  },
});

export const { 
  setSelectedRowKeys, 
  clearSelectedRowKeys,
  setCryptoDepositData,
  setCryptoWithdrawalData,
  setInrDepositData,
  setInrWithdrawalData,
  clearAllTransactionData,
  setLoadingCryptoDeposit,
  setLoadingCryptoWithdrawal,
  setLoadingInrDeposit,
  setLoadingInrWithdrawal,
  setCarretBankList,
  setLoadingCarretBankList
} = transactionSlice.actions;
export default transactionSlice.reducer;
